import { invokeApi } from "../../bl_libs/invokeApi";

export const login = async (data) => {
  const requestObj = {
    path: `api/member/login`,
    method: "POST",
    headers: {},
    postData: data,
  };
  return invokeApi(requestObj);
};

export const login_as_customer = async (data) => {
  const requestObj = {
    path: `api/member/login_by_email`,
    method: "POST",
    headers: {},
    postData: data,
  };
  return invokeApi(requestObj);
};
export const login_by_admin_api = async (data) => {
  const requestObj = {
    path: `app/login_impersonate_user`,
    method: "POST",
    headers: {},
    postData: data,
  };
  return invokeApi(requestObj);
};

export const confirmEmail = async (data) => {
  const requestObj = {
    path: `api/member/forgot_password_send_verification_code`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const confirmPinCode = async (data) => {
  const requestObj = {
    path: `api/member/email_code_verification`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const updatePassword = async (data) => {
  const requestObj = {
    path: `api/member/reset_password`,
    method: "POST",
    postData: data,
  };
  return invokeApi(requestObj);
};

export const chanePassword = async (data) => {
  const requestObj = {
    path: `api/member/member_change_password`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
